import { lazy } from 'react'
import { filterRoutes } from '../utils/util'
import { getManageCenterRoutes } from './manageRoutes'
import { getH5Routes } from './h5Routes'

import type { ResourceMap } from '../utils/consts'

const dataCenterRoutes = [
  {
    path: '/dataCenter',
    component: lazy(() => import(/* webpackChunkName: "dataCenter" */ '../pages/dataCenter')),
  },
]

const getRoutes = (resourceMap: ResourceMap, user: User, region: Region): Routes => {
  const { manageCenter, backgroundManage } = resourceMap
  const manageCenterRoutes = getManageCenterRoutes(manageCenter, user, region)
  const h5Routes = getH5Routes()
  const routes = [
    {
      path: '/login',
      component: lazy(() => import(/* webpackChunkName: "login" */ '../pages/login/login')),
    },
    {
      path: '/loginBlank',
      component: lazy(
        () => import(/* webpackChunkName: "loginBlank" */ '../pages/login/loginBlank')
      ),
    },
    {
      path: '/h5',
      component: require('../app/H5Layout').default,
      routes: h5Routes,
    },
    {
      path: '/',
      component: require('../app/Layout').default,
      routes: [
        ...dataCenterRoutes,
        ...manageCenterRoutes,
        ...[
          {
            path: '/background',
            resource: backgroundManage.index,
            component: require('../components/grayScaleTransition/offlinePage').default,
            routers: [],
          },
        ],
        { path: '*', component: require('../pages/notFound').default },
      ],
    },
  ]
  return filterRoutes(routes as Routes)
}

export default getRoutes
